import * as React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const AuthWrapper: React.FC<{}> = ({ children }) => {
  return <>{children}</>;
};
export default withAuthenticationRequired(AuthWrapper);
